// extracted by mini-css-extract-plugin
export default {"container":"styles_container__J72Gn","card":"styles_card__fbply","form":"styles_form__lTeEi","inputBlock":"styles_inputBlock__A-Ga5","loader":"styles_loader__+zcTr"};